<!--
    Styles
-->

<style>

    .ui-select svg {
        width: 16px;
        height: 16px;
    }

</style>



<!--
    Template
-->

<template>
    <a class="ui-select u-row">

        <div class="u-flex cl-black">
            <p class="label w5">{{ label }}</p>
            <p class="value t12">{{ value }}</p>
        </div>

        <icon-dropdown class="cl-blue" />

    </a>
</template>



<!--
    Scripts
-->

<script>


    import iconDropdown from '@/assets/icons/dropdown.svg'


    export default {

        components: {
            iconDropdown
        },

        props: [
            'label',
            'value'
        ]

    }

</script>
